import React from 'react'

const SignUpNavBar = () => {
    return (
        <div className={"bigDivSignUp"}>
            <h1 className={"headerTitle"}>Co-Make</h1>
        </div>
    )
}

export default SignUpNavBar
